import Session from 'supertokens-web-js/recipe/session';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { UserService } from 'app/core/user/user.service';
import { AppState } from 'app/store/app.reducer';
import { environment } from 'environments/environment';
import {
    catchError,
    from,
    Observable,
    of,
    Subscription,
    switchMap,
    throwError,
} from 'rxjs';
import * as AuthActions from 'app/store/actions/auth.actions';
import * as FinanciadoresActions from 'app/store/actions/financiadores.actions';
import * as PrestadoresActions from 'app/store/actions/prestadores.actions';
import * as LugaresAtencionActions from 'app/store/actions/lugaresAtencion.actions';

import { UsuarioAutenticado } from 'app/models/signIn.model';
import { PersistanceService } from '../../services/persistance.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class AuthService {
    private suscriptionStore: Subscription = new Subscription();

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _userService: UserService,
        private store: Store<AppState>,
        private presistanceSvc: PersistanceService,
        private cookieService: CookieService
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    /*     set accessToken(token: string) {
            localStorage.setItem('accessToken', token);
        } */

    get accessToken(): string {
        let accessToken = '';
        this.store.select('auth').subscribe((auth) => {
            accessToken = auth.auth?.token;
        });
        return accessToken;
    }

    get currentUser(): any {
        let currentUser: UsuarioAutenticado;
        this.store.select('auth').subscribe((auth) => {
            currentUser = auth.auth;
        });
        return currentUser;
    }

    get authenticated(): boolean {
        let authenticated = false;
        this.store.select('auth').subscribe((auth) => {
            if (auth.auth?.token != null) {
                authenticated = true;
            } else {
                authenticated = false;
            }
        });
        return authenticated;
    }

    get operatorRole(): boolean {
        let operatorRole = false;
        this.store.select('auth').subscribe((auth) => {
            console.log('auth.auth?.userRole', auth.auth?.userRole);

            if (auth.auth?.userRole.includes('OPERADOR')) {
                operatorRole = true;
            } else {
                operatorRole = false;
            }
        });
        console.log('operatorRole', operatorRole);

        return operatorRole;
    }

    get adminRole(): boolean {
        let adminRole = false;
        this.store.select('auth').subscribe((auth) => {
            console.log('auth.auth?.userRole', auth.auth?.userRole);

            if (auth.auth?.userRole.includes('ADMIN')) {
                adminRole = true;
            } else {
                adminRole = false;
            }
        });
        console.log('adminRole', adminRole);

        return adminRole;
    }

    get anyOSDERole(): boolean {
        let anyOSDERole = false;
        this.store.select('auth').subscribe((auth) => {
            console.log('auth.auth?.userRole', auth.auth?.userRole);

            if (auth.auth?.userGroup.includes('OSDE')) {
                anyOSDERole = true;
            } else {
                anyOSDERole = false;
            }
        });
        console.log('anyOSDERole', anyOSDERole);

        return anyOSDERole;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(email: string): Observable<any> {
        return this._httpClient.post('api/auth/forgot-password', email);
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPassword(password: string): Observable<any> {
        return this._httpClient.post('api/auth/reset-password', password);
    }

    get headers_http() {
        let header = {
            'Content-Type': 'application/json',
            Authorization:
                'Bearer ' + this.cookieService.get('st-access-token'),
            // 'Bearer ' + this.accessToken,
        };
        return { headers: header };
    }
    get headers() {
        let header = {
            Authorization:
                'Bearer ' + this.cookieService.get('st-access-token'),
            // 'Bearer ' + this.accessToken,
        };
        return header;
    }

    get headers_http_FormData() {
        let header = {
            Authorization:
                `Bearer ` + this.cookieService.get('st-access-token'),
        };
        return { headers: header };
    }

    /**
     * Sign in
     *
     * @param credentials
     */
    signIn(credentials: { email: string; password: string }) {
        return this._httpClient
            .post(environment.url + '/usuarios/login', credentials)
            .pipe(
                switchMap((response: any) => {
                    if (response.response.token !== '') {
                        this.store.dispatch(
                            new AuthActions.SetAuthenticated(response.response)
                        );
                        return of(response);
                    }
                }),
                catchError((error) => {
                    return throwError(
                        'Error al iniciar sesión. Por favor, inténtalo de nuevo.'
                    );
                })
            );
    }

    /**
     * Sign in using the access token
     */
    signInUsingToken(): Observable<any> {
        // Sign in using the token
        return this._httpClient
            .post('api/auth/sign-in-with-token', {
                accessToken: this.accessToken,
            })
            .pipe(
                catchError(() =>
                    // Return false
                    of(false)
                ),
                switchMap((response: any) => {
                    // Replace the access token with the new one if it's available on
                    // the response object.
                    //
                    // This is an added optional step for better security. Once you sign
                    // in using the token, you should generate a new one on the server
                    // side and attach it to the response object. Then the following
                    // piece of code can replace the token with the refreshed one.
                    if (response.accessToken) {
                        this.store.dispatch(
                            new AuthActions.SetAuthenticated(response)
                        );
                    }

                    // Set the authenticated flag to true
                    /*                 this._authenticated = true;
                     */
                    // Store the user on the user service
                    /*                 this._userService.user = response.user;
                     */
                    // Return true
                    return of(true);
                })
            );
    }

    /**
     * Sign out
     */
    signOut(): Observable<any> {
        // Remove the access token from the local storage
        this.store.dispatch(new AuthActions.UnsetAuthenticated());
        this.store.dispatch(new FinanciadoresActions.UnsetFinanciador());
        this.store.dispatch(new PrestadoresActions.UnsetPrescriptors());
        this.store.dispatch(new LugaresAtencionActions.UnsetLugaresAtencion());
        localStorage.clear();
        sessionStorage.clear();
        return of(true);
    }

    /**
     * Sign up
     *
     * @param user
     */
    signUp(user: {
        name: string;
        email: string;
        password: string;
        company: string;
    }): Observable<any> {
        return this._httpClient.post('api/auth/sign-up', user);
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: {
        email: string;
        password: string;
    }): Observable<any> {
        return this._httpClient.post('api/auth/unlock-session', credentials);
    }

    /**
     * Check the authentication status
     */
    check(): Observable<boolean> {
        // console.log("TOKEN DE ACCESO ?: " + this.authenticated)
        if (!this.accessToken) {
            // console.log("No hay token de acceso.")
            return of(false);
        }

        // Check if the user is logged in
        if (this.authenticated == true) {
            // console.log("USUARIO AUTENTICADO")
            return of(true);
        }

        // Check the access token availability

        // Check the access token expire date
        if (AuthUtils.isTokenExpired(this.accessToken)) {
            // console.log("El token de acceso ha expirado.")
            return of(false);
        }

        // If the access token exists, and it didn't expire, sign in using it
        return this.signInUsingToken();
    }

    /**
     * Check the user role
     */
    checkRole(): Observable<boolean> {
        // Check if the user is an operator
        if (this.anyOSDERole == true) {
            return of(false);
        } else if (this.operatorRole == true) {
            // console.log("USUARIO OPERADOR")
            return of(true);
        } else if (this.adminRole == true) {
            // console.log("USUARIO OPERADOR")
            return of(true);
        } else {
            return of(false);
        }
    }

    /**
     * Check the contactosURL
     */
    checkContactosURL(): Observable<boolean> {
        // Check if the user is an operator
        if (this.operatorRole == true) {
            // console.log("USUARIO OPERADOR")
            return of(true);
        } else {
            return of(false);
        }
    }

    deleteTest() {
        return this._httpClient
            .delete(
                environment.url + '/supertokens/user/delete',
                this.headers_http
            )
            .subscribe((response) => {
                console.log('response', response);
            });
    }
}
